import React from 'react'
import moment from 'moment-mini'
import reservation from '../../../../mockHttp/validReservation.json'
import terminal from '../../../../mockHttp/admin/terminals.json'
import { getCSCId } from '../../../../actions/api'
import './seawaybill.less'
import i18next from 'i18next'
import { useTranslation } from 'react-i18next'
import _ from 'lodash'
import logo from '../../../../assets/tallink.png'

interface Props {
  currentFont: string
  fontIncreaser: number
}

export const ports: { [key: string]: string } = {
  HEL: 'Helsinki',
  RIG: 'Riga',
  TAL: 'Tallinn',
  STO: 'Stockholm',
  TUR: 'Turku',
  SAS: 'Sassnitz',
  PAL: 'Paldiski',
}

const phoneNumbers: { [key: string]: string } = {
  HEL: '+358(0)20374266 / +46(0)86663555',
  RIG: '+37267099707',
  TAL: '+3726128686',
  STO: '',
  TUR: '',
  SAS: '',
  PAL: '',
}

const location = 'HEL'
const gate = 'A'
const harbour = 'West'
const terminalID = getCSCId()
const defaultFirstInstruction = 'Gate opens 2 h before departure.'
const defaultSecondInstruction = 'Get your cabin key by showing this QR code to the machine near the ship’s info desk.'
const defaultFirstSwbField = 'SAVE THIS WAYBILL UNTIL ARRIVAL'
const defaultSecondSwbField = 'HAVE A PLEASANT VOYAGE!'

const fullDateFormat = (date: number) => moment(date).format('DD.MM.YYYY HH:mm')

const SeaWayBill: React.FC<Props> = ({ currentFont, fontIncreaser }: Props) => {
  const scanImage = reservation.drivers[0].scanImage
  const { t } = useTranslation()
  const currentLang = i18next.language || 'en'
  let instruction1, instruction2
  if (terminal[0]) {
    instruction1 = _.get(
      terminal[0],
      `firstInstruction.${currentLang}`,
      _.get(terminal[0], 'firstInstruction.en', defaultFirstInstruction),
    )
    instruction2 = _.get(
      terminal[0],
      `secondInstruction.${currentLang}`,
      _.get(terminal[0], 'secondInstruction.en', defaultSecondInstruction),
    )
  }

  const instruction =
    t('Drive to') +
    ' ' +
    t('gate') +
    ' ' +
    gate +
    ' ' +
    t('in') +
    ' ' +
    ports[location] +
    ' ' +
    harbour +
    ' ' +
    t('harbour') +
    '.' +
    ' ' +
    instruction1
  const totalWeight = reservation.cargoUnit.cargoWeight + reservation.cargoUnit.weight
  let diffFontSizes = {
    block1: 15,
    block2: 14,
    block3: 12,
    block4: 13,
    tw: 27,
    title: 20,
  }
  return (
    <div className="seawaybill" style={{ fontFamily: currentFont, fontSize: 15 + fontIncreaser }}>
      <div className="inner">
        <div className="container">
          <div className="header-swb bold">
            <div className="block">
              <img className="logo-swb" src={logo} alt="logo" />
            </div>
            <div className="block">
              <img className="qr" src={scanImage} alt="qr" />
            </div>
            <div className="block1 instructions-header" style={{ fontSize: diffFontSizes.block1 + fontIncreaser }}>
              <div className="block">
                <div>{instruction}</div>
              </div>
              <div className="block">
                <div>{instruction2}</div>
              </div>
            </div>
            <div className="block">
              <div className="tw" style={{ fontSize: diffFontSizes.tw + fontIncreaser }}>
                TW: {totalWeight} kg
              </div>
            </div>
            <div className="block">
              <div className="title" style={{ fontSize: diffFontSizes.title + fontIncreaser }}>
                SEAWAYBILL / TICKET
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="block block1" style={{ fontSize: diffFontSizes.block1 + fontIncreaser }}>
            <div className="row">
              <div className="label">BOOKING ID: </div>
              <div className="value">{reservation.resId}</div>
            </div>
          </div>

          <div className="block block1" style={{ fontSize: diffFontSizes.block1 + fontIncreaser }}>
            <div className="row">
              <div className="label">SHIP: </div>
              <div className="value">{reservation.route.ship}</div>
            </div>
            <div className="row">
              <div className="label">ROUTE: </div>
              <div className="value">
                {ports[reservation.route.portFrom]}-{ports[reservation.route.portTo]}
              </div>
            </div>
            <div className="row">
              <div className="label">DEPARTURE: </div>
              <div className="value">{fullDateFormat(reservation.route.dateFrom)}</div>
            </div>
          </div>

          <div className="block block2" style={{ fontSize: diffFontSizes.block2 + fontIncreaser }}>
            <div className="row">
              <div className="label">DRIVERS ({reservation.drivers.length}): </div>
            </div>
            <div className="row">
              <div className="value">1. </div>
              <div className="value">{`${reservation.drivers[0].firstName} ${reservation.drivers[0].lastName}`}</div>
            </div>
            {reservation.drivers.length > 1 ? (
              <div className="row">
                <div className="value">2. </div>
                <div className="value">{`${reservation.drivers[1].firstName} ${reservation.drivers[1].lastName}`}</div>
              </div>
            ) : (
              <div />
            )}
          </div>

          <div className="block block2" style={{ fontSize: diffFontSizes.block2 + fontIncreaser }}>
            <div className="row">
              <div className="label">TRAVEL CLASS:</div>
              <div className="value">{t(reservation.drivers[0].cabinCategory)}</div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="block block3" style={{ fontSize: diffFontSizes.block3 + fontIncreaser }}>
            <div className="row">
              <div className="label">CUSTOMER: </div>
            </div>
            <div className="row">
              <div className="value">{reservation.customerName}</div>
            </div>
          </div>

          <div className="block block3" style={{ fontSize: diffFontSizes.block3 + fontIncreaser }}>
            <div className="row">
              <div className="label">CONSIGNEE: </div>
            </div>
            <div className="row">
              <div className="value">{reservation.consigneeName}</div>
            </div>
          </div>

          <div className="block block3" style={{ fontSize: diffFontSizes.block3 + fontIncreaser }}>
            <div className="row">
              <div className="label">CONTENT: </div>
            </div>
            <div className="row">
              <div className="value">{reservation.content}</div>
            </div>
          </div>

          <div className="block block3" style={{ fontSize: diffFontSizes.block3 + fontIncreaser }}>
            <div className="label">REGISTRATION DATA:</div>
            {reservation.cargoUnit.trailerRegNumber ? (
              <div>
                <div className="row">
                  <div className="value half">TRUCK</div>
                  <div className="value half">{reservation.cargoUnit.regNumber}</div>
                </div>
                <div className="row">
                  <div className="value half">TRAILER</div>
                  <div className="value half">{reservation.cargoUnit.trailerRegNumber}</div>
                </div>
              </div>
            ) : (
              <div>
                <div className="row">
                  <div className="value half">TRUCK</div>
                  <div className="value half">{reservation.cargoUnit.regNumber}</div>
                </div>
                <div className="row">
                  <div className="value half">{reservation.cargoType}</div>
                </div>
              </div>
            )}
          </div>

          <div className="block block3 dimensions" style={{ fontSize: diffFontSizes.block3 + fontIncreaser }}>
            <div className="half">
              <div className="row">
                <div className="value">LENGTH: </div>
                <div className="value">{reservation.cargoUnit.length} M</div>
              </div>
              <div className="row">
                <div className="value">HEIGHT: </div>
                <div className="value">{reservation.cargoUnit.height} M</div>
              </div>
            </div>
            <div className="half">
              <div className="row">
                <div className="value">WIDTH: </div>
                <div className="value">{reservation.cargoUnit.width} M</div>
              </div>
              <div className="row">
                <div className="value">WEIGHT: </div>
                <div className="value">{reservation.cargoUnit.cargoWeight} KG</div>
              </div>
            </div>
          </div>
        </div>
        <div className="block block3" style={{ fontSize: diffFontSizes.block3 + fontIncreaser }}>
          <div className="row bold">
            <div className="label">TALLINK SILJA CARGO</div>
          </div>
          <div className="row">
            <div className="value">Tel: </div>
            <div className="value">{phoneNumbers['TAL']}</div>
          </div>
        </div>
        <div className="block block4 instructions bold" style={{ fontSize: diffFontSizes.block4 + fontIncreaser }}>
          <div className="row">
            <div className="value">{t('firstSwbField') || defaultFirstSwbField}</div>
          </div>
          <div className="row">
            <div className="value">{t('secondSwbField') || defaultSecondSwbField}</div>
          </div>
        </div>
        <div className="block block3" style={{ fontSize: diffFontSizes.block3 + fontIncreaser }}>
          <div className="row">
            <div className="value">TERMINAL ID: </div>
            <div className="value">{terminalID}</div>
          </div>
          <div className="row">
            <div className="value">{moment().format('DD.MM.YYYY HH:mm')} </div>
          </div>
        </div>
        <br />
        &nbsp;
        <br />
        &nbsp;
        <div className="page-break" />
      </div>
    </div>
  )
}

export default SeaWayBill
